import { useAppState } from '../../AppStateProvider';
import UrlService from '../../services/UrlService';

import type { EmptyStateVariant } from './styles';
import { EmptyPageVariant } from './types';

const emptyPageConfig: {
  [key in EmptyPageVariant]: { img: string; variant: EmptyStateVariant; textKey?: string; messageKey?: string };
} = {
  [EmptyPageVariant.LinkedIn]: {
    img: '/images/empty-state-girl-in.svg',
    variant: 'girl-in',
    textKey: 'home.empty_state.text',
    messageKey: 'home.empty_state.message',
  },
  [EmptyPageVariant.Salesloft]: {
    img: '/images/empty-state-salesloft.svg',
    variant: 'girl-crm',
    textKey: 'home.empty_state.crm.text',
    messageKey: 'home.empty_state.message',
  },
  [EmptyPageVariant.HubSpot]: {
    img: '/images/empty-state-girl-hubspot.svg',
    variant: 'girl-crm',
    textKey: 'home.empty_state.crm.hubspot.text',
    messageKey: 'home.empty_state.message',
  },
  [EmptyPageVariant.MicrosoftDynamics]: {
    img: '/images/empty-state-girl-microsoft-dynamics.svg',
    variant: 'girl-crm',
    textKey: 'home.empty_state.crm.text',
    messageKey: 'home.empty_state.message',
  },
  [EmptyPageVariant.Salesforce]: {
    img: '/images/empty-state-girl-salesforce.svg',
    variant: 'girl-crm',
    textKey: 'home.empty_state.crm.text',
    messageKey: 'home.empty_state.message',
  },
  [EmptyPageVariant.Gmail]: {
    img: '/images/empty-state-girl-gmail.svg',
    variant: 'girl-crm',
    textKey: 'home.empty_state.gmail.text',
    messageKey: 'home.empty_state.gmail.message',
  },
  [EmptyPageVariant.GoogleSheets]: {
    img: '/images/empty-state-girl-google-sheets.svg',
    variant: 'girl-crm',
    textKey: 'home.empty_state.google_sheets.text',
    messageKey: 'home.empty_state.google_sheets.message',
  },
};

export const mapUrlToEmptyStatePageConfig = (urlString: string) => {
  const url = UrlService.createEventUrl(urlString);
  if (UrlService.isLinkedinUrl(url)) {
    return emptyPageConfig[EmptyPageVariant.LinkedIn];
  }
  if (UrlService.isSalesloftUrl(url)) {
    return emptyPageConfig[EmptyPageVariant.Salesloft];
  }
  if (UrlService.isHubspotUrl(url)) {
    return emptyPageConfig[EmptyPageVariant.HubSpot];
  }
  if (UrlService.isMicrosoftDynamicsUrl(url)) {
    return emptyPageConfig[EmptyPageVariant.MicrosoftDynamics];
  }
  if (UrlService.isSalesforceUrl(url) || UrlService.isSalesforceLightningUrl(url)) {
    return emptyPageConfig[EmptyPageVariant.Salesforce];
  }
  if (UrlService.isGmailUrl(url)) {
    return emptyPageConfig[EmptyPageVariant.Gmail];
  }
  if (UrlService.isGoogleSheetsUrl(url)) {
    return emptyPageConfig[EmptyPageVariant.GoogleSheets];
  }
};

export const useHomePageEmptyState = () => {
  const { url } = useAppState();

  return mapUrlToEmptyStatePageConfig(url!);
};
